import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faFolders, faMinus } from '@fortawesome/sharp-regular-svg-icons';

type DossierProcessesBulkActionsBarProps = {
    selectedIds: number[];
    onClearSelection: () => void;
    canDissociate: boolean;
    onDissociate: () => void;
    canMove: boolean;
    onMove: () => void;
};

const DossierProcessesBulkActionsBar: React.FunctionComponent<DossierProcessesBulkActionsBarProps> =
    function ({ selectedIds, onClearSelection, canDissociate, onDissociate, canMove, onMove }) {
        const { palette } = useTheme();

        if (selectedIds.length === 0) {
            return null;
        }

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    gap: '8px',
                    paddingLeft: '19px',
                }}
            >
                <Box
                    sx={{
                        border: `${palette.primary.main} 1px solid`,
                        width: '20px',
                        height: '20px',
                        borderRadius: '6px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                    onClick={onClearSelection}
                >
                    <FontAwesomeIcon icon={faMinus} />
                </Box>
                <Typography
                    variant="l2dcaption"
                    sx={{ display: 'block' }}
                >
                    {selectedIds.length} sélection(s)
                </Typography>
                {canDissociate && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                        }}
                        onClick={onDissociate}
                    >
                        <FontAwesomeIcon icon={faFolders} />
                        Dissocier
                    </Box>
                )}
                {canMove && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                        }}
                        onClick={onMove}
                    >
                        <FontAwesomeIcon icon={faFileImport} />
                        Déplacer
                    </Box>
                )}
            </Box>
        );
    };

export default DossierProcessesBulkActionsBar;
